/* eslint-disable import/no-unassigned-import */
import App from './App';
import './index.css';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

// const postHogOptions = {
//   api_host: import.meta.env.VITE_REACT_APP_PUBLIC_POSTHOG_HOST,
// };

const container = document.querySelector('#root');
if (container) {
  const root = createRoot(container);

  root.render(
    <StrictMode>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </StrictMode>,
  );
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
}
